import { AccordionDetails as MUIAccordionDetails } from '@mui/material';
import { styled } from '@frontend/theme';

export const MUIAccordionDetailsSt = styled(MUIAccordionDetails)(() => ({
  '&.MuiAccordionDetails-root': {
    padding: '0px',
  },
}));
